import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, UnmutedMicrophoneIcon } from '@streamr/tv-ui';
import { useRef, useState } from 'react';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { UserService } from '../../services/user/UserService';
import { AcceptedParticipantType, UserRole, } from '../../services/user/UserServiceOutput';
import { Anchor } from '../Anchor';
import { showPrivateChatPopup } from '../popups/PrivateChatPopup';
import { showRequestSpeakerRolePopup } from '../popups/RequestSpeakerRolePopup';
import { showSpeakersPopup } from '../popups/SpeakersPopup';
export function RequestToSpeakButton() {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const userRole = UserService.getOutput().useUserRole();
    const outgoingRequests = UserService.getOutput().useOutgoingRequests();
    const acceptedParticipantType = UserService.getOutput().useAcceptedParticipantType();
    const requestButtonAnchorRef = useRef(null);
    const [isRequestSpeakerRolePopupOpen, setIsRequestSpeakerRolePopupOpen] = useState(false);
    if (userRole !== UserRole.COHOST &&
        acceptedParticipantType === AcceptedParticipantType.NONE) {
        return null;
    }
    const isCallMode = acceptedParticipantType === AcceptedParticipantType.SPEAKERS;
    const isGuestMode = acceptedParticipantType === AcceptedParticipantType.GUESTS;
    const requestedRole = isGuestMode ? UserRole.GUEST : UserRole.SPEAKER;
    const buttonLabel = outgoingRequests.length > 0
        ? isGuestMode
            ? 'Requesting to speak'
            : 'Requesting to join'
        : isGuestMode
            ? 'Request to speak'
            : 'Request to join';
    return (_jsx(Anchor, { ref: requestButtonAnchorRef, style: {
            visibility: isRequestSpeakerRolePopupOpen
                ? 'hidden'
                : undefined,
        }, children: _jsxs(StyledRequestButton, { active: isRequestSpeakerRolePopupOpen, onClick: () => {
                if (userRole === UserRole.COHOST) {
                    showSpeakersPopup({
                        anchorRef: requestButtonAnchorRef,
                        variant: 'desktop',
                        onBeforeOpen: () => {
                            setIsRequestSpeakerRolePopupOpen(true);
                        },
                        onDismiss: () => {
                            setIsRequestSpeakerRolePopupOpen(false);
                        },
                    });
                }
                else if (outgoingRequests.length > 0) {
                    if (!isCallMode) {
                        showPrivateChatPopup({
                            anchorRef: requestButtonAnchorRef,
                            hostUserId: activeBroadcast.broadcasterUserId,
                            onBeforeOpen: () => {
                                setIsRequestSpeakerRolePopupOpen(true);
                            },
                            onDismiss: () => {
                                setIsRequestSpeakerRolePopupOpen(false);
                            },
                        }).catch(() => { });
                    }
                }
                else {
                    showRequestSpeakerRolePopup({
                        anchorRef: requestButtonAnchorRef,
                        hostUserId: activeBroadcast.broadcasterUserId,
                        requestedRole,
                        isCallMode,
                        onBeforeOpen: () => {
                            setIsRequestSpeakerRolePopupOpen(true);
                        },
                        onDismiss: () => {
                            setIsRequestSpeakerRolePopupOpen(false);
                        },
                    }).catch(() => { });
                }
            }, children: [_jsx(UnmutedMicrophoneIcon, { fill: "currentColor" }), buttonLabel] }) }));
}
const StyledRequestButton = styled(Button) `
    --Button_Background: #2f2f2f;
    --Button_ActiveBackground: #404040;
    --Button_TextColor: var(--tv-ui-color-3);
    --Button_Padding: 0 1.5rem;
    --Button_BorderRadius: 1.5rem;
    --Button_Height: 3rem;
    gap: 0.5rem;
`;
